import axios from "axios";
import {getHeader, plansUrl} from "../../config";
import {types} from "../types/globalTypes";
import {planTypes} from "../types/planTypes";


export const getPlans = () => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.get(plansUrl, {headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                dispatch({
                    type: planTypes.GET_PLANS,
                    payload: response.data.Response.plans,
                });
            }
        }).catch(error => {
            if (error) {
                console.log("error here", error);
                dispatch({
                    type: types.ERROR_500,
                    payload: true,
                });

            }
        })
    }
};